import * as kpisServices from '@/services/kpis.js'
import * as campaigns from '@/services/campaigns.js'

export default {
  async gerarEncarte({ state, commit }, filter) {
    const { data } = await kpisServices.resultadosEncarte(filter)
    commit('SET_OBJECT', { name: 'dadosEncarte', data, state })
    return data
  },
  async listarCampanhas({ state, commit }, filter = {}) {
    const data = await campaigns.listarCampanhas(filter)
    commit('SET_OBJECT', { name: 'listaCampanhas', data, state })
    return data
  },
  async getSmsCredits({ state, commit }) {
    const data = await campaigns.getSmsCredits()
    commit('SET_OBJECT', { name: 'smsCredits', data, state })
  },
  async getActiveCampaignsQuarter({ state, commit }) {
    const data = await campaigns.getActiveCampaignsQuarter()
    commit('SET_OBJECT', { name: 'activeCampaignsQuarter', data, state })
  },
  async removerCampanha({ state, commit }, id) {
    const data = await campaigns.removeCampaign(id)
    return data
  },
  async campaignsCount({ state }, filter) {
    const data = await campaigns.campaignsCount(filter)
    return data
  },
  async duplicateCampaign({ state, commit }, id) {
    const data = await campaigns.duplicateCampaign(id)
    return data
  },
  setSegmentos({ commit }, segmentos) {
    commit('SET_SEGMENTOS', segmentos)
  },
}
